import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "dropdown" }
const _hoisted_2 = {
  class: "dropdown-menu",
  "aria-labelledby": "dropdownMenu2"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("button", {
      class: "btn btn-light float-end",
      type: "button",
      id: "dropdownMenu2",
      "data-bs-toggle": "dropdown",
      "aria-expanded": "false"
    }, [
      _createElementVNode("span", { class: "visually-hidden" }, "Options"),
      _createElementVNode("i", { class: "bi bi-three-dots-vertical" })
    ], -1)),
    _createElementVNode("ul", _hoisted_2, [
      (_ctx.permissions?.canView)
        ? (_openBlock(), _createElementBlock("li", _hoisted_3, [
            _createElementVNode("button", {
              class: "dropdown-item",
              type: "button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('viewClicked', _ctx.id)))
            }, " View ")
          ]))
        : _createCommentVNode("", true),
      (_ctx.permissions?.canEdit)
        ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
            _createElementVNode("button", {
              class: "dropdown-item",
              type: "button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('editClicked', _ctx.id)))
            }, " Edit ")
          ]))
        : _createCommentVNode("", true),
      (_ctx.permissions?.canDelete)
        ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
            _createElementVNode("button", {
              class: "dropdown-item",
              type: "button",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('deleteClicked', _ctx.id)))
            }, " Delete ")
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}